import React from 'react'
import { connect } from 'react-redux'

import { NavigationMenuKey, RouteKey } from '@store/constants'
import { ProjectIdentity, RootStateTypeExtra } from '@store/types'

import { ProjectType } from '@utilities/adgroup-utilities/constants/common'

import FirebaseControlQuery from '@firebaseUtil/firebase-control-query'

interface EmptyStateProps {
  projectIdentity: ProjectIdentity
}

function EmptyState({ projectIdentity }: EmptyStateProps) {
  const firebaseControlQuery = FirebaseControlQuery({
    ...projectIdentity,
    sessionKey: projectIdentity.sessionId,
  })

  const {
    isSnaploaderActive: hasSnaploader,
    isEnvisionVRActive: hasEnvisionVR,
    showcase3DIntegration,
    type,
    navigationSettings,
  } = projectIdentity

  const handleNavigateToResidences = () => {
    if (showcase3DIntegration) {
      firebaseControlQuery.updateRoute(RouteKey.ADTHREED)
      return
    }

    if (type === ProjectType.HouseAndLand) {
      firebaseControlQuery.updateRoute(RouteKey.AREA_VIEW_HOUSE_AND_LAND)
      return
    }

    if (hasSnaploader) {
      firebaseControlQuery.updateRoute(RouteKey.SNAPLOADER_VIEW)
      return
    }

    if (hasEnvisionVR) {
      firebaseControlQuery.updateRoute(RouteKey.THREE_D_BUILDING)
      return
    }

    firebaseControlQuery.updateRoute(RouteKey.AREA_VIEW)
  }

  const exploreLinkText = React.useMemo(() => {
    const dynamicResidencesText = navigationSettings?.find(
      (item) => item.key === NavigationMenuKey.RESIDENCES
    )
    if (dynamicResidencesText && dynamicResidencesText.label) {
      return `Explore ${dynamicResidencesText.label?.toLowerCase()}`
    }

    if (type === ProjectType.HouseAndLand) {
      return 'Explore Precinct'
    }

    return 'Explore Residences'
  }, [navigationSettings])

  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <p className="mb-6 text-3xl font-semibold leading-none">
        Your Shortlist is empty
      </p>
      <p className="mb-11 text-[26px] leading-none">
        Add your favourite properties in it.
      </p>
      <button
        type="button"
        className="rounded-lg bg-mainColour px-12 py-5 text-[19px] font-semibold capitalize leading-none text-white"
        onClick={handleNavigateToResidences}
      >
        {exploreLinkText}
      </button>
    </div>
  )
}

export default connect(({ projectIdentity }: RootStateTypeExtra) => ({
  projectIdentity,
}))(EmptyState)
